import { useState } from 'react';
import { cn } from '@mlm/ui';
import { productImageUrl, type PosProduct } from '../../lib/api';

/**
 * A product's first photo, or its initials on a muted block when it has none
 * (most catalogs here were entered without photos) or the photo fails to load.
 * One component for the tile, the cart line, the item sheet and the checkout
 * rows, so a product looks the same wherever it appears.
 */
export function ProductImage({
  product,
  className,
}: {
  product: Pick<PosProduct, 'id' | 'name' | 'images'>;
  /** Sizing and radius; the image always covers its box. */
  className?: string;
}) {
  const [broken, setBroken] = useState(false);
  if (product.images.length > 0 && !broken) {
    return (
      <img
        src={productImageUrl(product.id, 0)}
        alt=""
        loading="lazy"
        decoding="async"
        className={cn('bg-muted object-cover', className)}
        onError={() => setBroken(true)}
      />
    );
  }
  const initials = product.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
  return (
    <div
      aria-hidden
      className={cn(
        'flex items-center justify-center bg-muted text-xl font-semibold text-muted-foreground/60',
        className,
      )}
    >
      {initials}
    </div>
  );
}
